var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portfolio-filter-link',{attrs:{"filterLayout":_vm.filterLayout}}),_c('portfolio-list-link',{attrs:{"listLayout":_vm.listLayout,"portfolioData":_vm.List}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout,"type":_vm.portfolioType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }